<template>
  <div class="main-layout-wrap">
    <Header></Header>
    <div class="main-container">
      <router-view />
    </div>
  </div>
</template>
<script>
import Header from "../components/Header.vue"
export default {
  components: {
    Header,
  },
}
</script>
